import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate,  useLocation } from "react-router-dom";

import Skeleton from "react-loading-skeleton";

import { MotionDiv } from "../../components";
import { selectOptions } from "../../features/optionSlice";
import Title from "../../components/layout/Title";
import { useCreateOrUpdateHelpMutation, useFetchHelpPageMutation } from "../../features/apiSlice";
import TextEditor from "../../components/layout/TextEditor";
import { getError } from "../../utils/error";

export default function EditPage() {
  const navigate = useNavigate();

  const { subdomain } = useSelector(selectOptions);

  const [fetchHelpPage, { data, isLoading, error }] =
    useFetchHelpPageMutation();

     useEffect(() => {
      console.log('first',subdomain)
        if (subdomain) {
          fetchHelpPage(subdomain);
        }
      }, [subdomain, fetchHelpPage]);
    
  const [updatePage] = useCreateOrUpdateHelpMutation();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("Help");
  const [description, setDescription] = useState("");

  console.log(data)

useEffect(()=>{
    
  if(data){

    setTitle(data?.title);
    setDescription(data?.description)
  }
    
},[data])

 

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!title || !description) {
      toast.warning("Please Enter All Fields");
      return;
    }

    try {
      setLoading(true);
      const data =  await updatePage({ title, description, subdomain_reference: subdomain}).unwrap()
       
      setLoading(false);
      toast.success(data?.message);
      navigate(-1);
    } catch (error) {
      setLoading(false);
      getError(error);
    }
  };

 

  return (
    <MotionDiv>
      <Title>Help</Title>

      <Card className=" ">
        {isLoading ? (
          <Container className="p-4">
            <Skeleton height={30} count={5} />
          </Container>
        ) : (
          <Container className=" p-4">
            <Row className="align-items-center mb-4">
              <Col sm={12} md={3}>
                <Form.Label>Page Title</Form.Label>
              </Col>
              <Col sm={12} md={9}>
                <Form.Control
                  required
                  placeholder="Page Title"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                  type="text"
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col sm={12} md={3}>
                <Form.Label>Description</Form.Label>
              </Col>
              <Col sm={12} md={9}>
             

                <TextEditor
                  description={description}
                  setDescription={setDescription}
                />

              
              </Col>
            </Row>

         
            <Row className="my-3">
              <Col className="text-end" md={12}>
                <Button className="blue-btn px-4" onClick={submitHandler}>
                  {loading ? (
                    <Spinner size="sm" />
                  ) : "Update"
                  }
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      </Card>
    </MotionDiv>
  );
}
